import { render } from "./AwardsBlock.vue?vue&type=template&id=301f71de&scoped=true"
import script from "./AwardsBlock.vue?vue&type=script&lang=js"
export * from "./AwardsBlock.vue?vue&type=script&lang=js"

import "./AwardsBlock.vue?vue&type=style&index=0&id=301f71de&lang=scss&scoped=true"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301f71de"]])

export default __exports__